const preloader = document.getElementById('preloader');
if (preloader) {
  window.addEventListener('load', () => {
    // Get duration from data attribute (convert to milliseconds)
    const duration = (preloader.dataset.duration || 2) * 1000;

    setTimeout(() => {
      preloader.style.transition = 'opacity 1s';
      preloader.style.opacity = '0';
      // The moment fade-out begins, stop capturing scroll/touch input so
      // the user's first scroll lands on the page underneath instead of
      // the still-present (but transparent) overlay.
      preloader.style.pointerEvents = 'none';

      // Use setTimeout instead of animationend since we're using transition
      setTimeout(() => {
        preloader.style.display = 'none';
      }, 1000); // Wait for transition to complete

    }, duration);
  });
}